<template>
  <div class="tour-services">
    <div
      v-for="{ comment, id, name, price } in services"
      :key="id"
      class="tour-services__item"
    >
      <div v-if="comment" class="tour-services__tooltip u-flex-shrink-0">
        <tooltip>
          <template #default>
            <svg-inline class="u-decor u-text-secondary">
              <icon icon="icon-info" />
            </svg-inline>
          </template>
          <template #content>
            <div v-html="comment" />
          </template>
        </tooltip>
      </div>
      <div
        class="tour-services__name u-flex-grow font-semibold"
        v-html="name"
      ></div>
      <div class="tour-services__price u-flex-shrink-0 font-semibold">
        {{ symbol }} {{ price }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Tooltip from "@/components/ui-kit/tooltip/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";

export default {
  components: {
    Tooltip,
    SvgInline,
    Icon,
  },
  props: {
    services: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters("currency", ["symbol"]),
  },
};
</script>

<style lang="scss" scoped>
.tour-services {
  &__item {
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-top: 1px solid var.$gray-light;

    @include mixin.size-lg-min {
      padding: 24px 0;
    }

    > * + * {
      margin-left: 12px;
    }
  }

  &__tooltip {
    width: 18px;
  }
}
</style>
